export const rendersProductIndices = [
    "wisselstellers",
    "halveTongbewegingen",
    "smeerlozeConstructies",
    "nrglassen",
    "strijkregels",
    "puntstukken",
    "kruisstukken",
];
export const renderMap = {
    "NORMAL_SWITCH:ANGLE=LEFT": [
        "1. Wissel links 3840x2160.png",
        "1. Wissel links BW 3840x2160.png",
        "1. Wissel links WOOD 3840x2160.png",
        [
            "1. Wissel links 3840x2160/1.png",
            "1. Wissel links 3840x2160/2.png",
            "1. Wissel links 3840x2160/3.png",
            "1. Wissel links 3840x2160/4.png",
            "1. Wissel links 3840x2160/5.png",
            "1. Wissel links 3840x2160/6.png",
        ],
        "1. Wissel links 3840x2160/path.png",
    ],
    "NORMAL_SWITCH:ANGLE=RIGHT": [
        "2. Wissel rechts 3840x2160.png",
        "2. Wissel rechts BW 3840x2160.png",
        "2. Wissel rechts WOOD 3840x2160.png",
        [
            "2. Wissel rechts 3840x2160/1.png",
            "2. Wissel rechts 3840x2160/2.png",
            "2. Wissel rechts 3840x2160/3.png",
            "2. Wissel rechts 3840x2160/4.png",
            "2. Wissel rechts 3840x2160/5.png",
            "2. Wissel rechts 3840x2160/6.png",
        ],
        "2. Wissel rechts 3840x2160/path.png",
    ],
    "SYMMETRIC_SWITCH": [
        "3. Wissel symmetrisch 3840x2160.png",
        "3. Wissel symmetrisch BW 3840x2160.png",
        "3. Wissel symmetrisch WOOD 3840x2160.png",
        [
            "3. Wissel symmetrisch 3840x2160/1.png",
            "3. Wissel symmetrisch 3840x2160/2.png",
            "3. Wissel symmetrisch 3840x2160/3.png",
            "3. Wissel symmetrisch 3840x2160/4.png",
            "3. Wissel symmetrisch 3840x2160/5.png",
            "3. Wissel symmetrisch 3840x2160/6.png",
        ],
        "3. Wissel symmetrisch 3840x2160/path.png",
    ],
    "INTERSECTION_SWITCH": [
        "4. Kruising 3840x2160.png",
        "4. Kruising BW 3840x2160.png",
        "4. Kruising WOOD 3840x2160.png",
        [
            undefined, // wisselstellers
            undefined, // halveTongbewegingen
            undefined, // smeerlozeConstructies
            "4. Kruising 3840x2160/3.png", // nrg
            "4. Kruising 3840x2160/2.png", // strijk
            "4. Kruising 3840x2160/1.png", // punt
            "4. Kruising 3840x2160/4.png", // kruising
        ],
        "4. Kruising 3840x2160/path.png",
    ],
    "ENGLISH_SWITCH": [
        "5. Wissel engels 3840x2160.png",
        "5. Wissel engels BW 3840x2160.png",
        "5. Wissel engels WOOD 3840x2160.png",
        [
            "5. Wissel engels 3840x2160/1.png", // wisselstellers
            "5. Wissel engels 3840x2160/4.png", // halveTongbewegingen
            "5. Wissel engels 3840x2160/5.png", // smeerlozeConstructies
            "5. Wissel engels 3840x2160/3.png", // nrg
            "5. Wissel engels 3840x2160/2.png", // strijk
            "5. Wissel engels 3840x2160/6.png", // punt
            "5. Wissel engels 3840x2160/7.png", // kruising
        ],
        "5. Wissel engels 3840x2160/path.png",
    ],
    "HALF_ENGLISH_SWITCH": [
        "6. Wissel engels half 3840x2160.png",
        "6. Wissel engels half BW 3840x2160.png",
        "6. Wissel engels half WOOD 3840x2160.png",
        [
            "6. Wissel engels half 3840x2160/1.png", // wisselstellers
            "6. Wissel engels half 3840x2160/4.png", // halveTongbewegingen
            "6. Wissel engels half 3840x2160/5.png", // smeerlozeConstructies
            "6. Wissel engels half 3840x2160/3.png", // nrg
            "6. Wissel engels half 3840x2160/2.png", // strijk
            "6. Wissel engels half 3840x2160/6.png", // punt
            "6. Wissel engels half 3840x2160/7.png", // kruising
        ],
        "6. Wissel engels half 3840x2160/path.png",
    ]
};
export const renderPosMap = {
    "NORMAL_SWITCH:ANGLE=LEFT": {
        "wisselstellers": {
            x: "20.5%", y: "44.5%",
            rect: [
                { x: "19%", y: "50%", width: "10%", height: "10%", clip: "-6% 33%, -6% 31%, 40% 0%, 79% 52%, 31% 84%" }
            ]
        },
        "halveTongbewegingen": {
            x: "39%", y: "38%",
            rect: [
                { x: "23%", y: "36%", width: "33%", height: "23%", clip: "0% 92%, 100% -10%, 95% 4%, 1% 103%" },
                { x: "28%", y: "41%", width: "29%", height: "23%", clip: "0% 92%, 100% -5%, 98% 7%, 1% 103%" }
            ]
        },
        "smeerlozeConstructies": {
            x: "34.5%", y: "41.1%",
            rect: [
                { x: "35%", y: "48.6%", width: "3.2%", height: "3.2%", clip: "0% 72%, 85% 0%, 100% 42%, 17% 103%" },
                { x: "39.3%", y: "53.7%", width: "3.6%", height: "2.9%", clip: "0% 72%, 85% 0%, 93% 28%, 17% 100%" },
            ]
        },
        "nrglassen": {
            x: "62.2%", y: "19.9%",
            rect: [
                { x: "63%", y: "26%", width: "2%", height: "2.5%", clip: "0% 58%, 90% -3%, 113% 30%, 19% 90%" },
                { x: "67%", y: "29.1%", width: "1.9%", height: "2.9%", clip: "0% 58%, 90% -3%, 113% 30%, 19% 90%" }
            ]
        },
        "strijkregels": {
            x: "69.5%", y: "13.1%",
            rect: [
                { x: "69.5%", y: "17.4%", width: "5.2%", height: "5.3%", clip: "0% 84%, 95% 0, 114% 10%, 19% 103%" },
                { x: "75.6%", y: "21.7%", width: "6.2%", height: "5.4%", clip: "0% 84%, 95% 0, 114% 10%, 19% 103%" }
            ]
        },
        "puntstukken": {
            x: "75%", y: "8%",
            rect: [
                { x: "73.4%", y: "19%", width: "5.3%", height: "5.7%", clip: "0% 69%, 77% 0%, 115% 22%, 21% 92%" }
            ]
        },
    },
    "NORMAL_SWITCH:ANGLE=RIGHT": {
        "wisselstellers": {
            x: "37%", y: "64%",
            tooltipBottom: true,
            rect: [
                { x: "29.2%", y: "63.2%", width: "7.7%", height: "9.9%", clip: "0% 37%, -3% 29%, 48% 0%, 85% 46%, 36% 73%" }
            ]
        },
        "halveTongbewegingen": {
            x: "39%", y: "38%",
            rect: [
                { x: "23.5%", y: "37%", width: "29.2%", height: "21%", clip: "0% 92%, 110% -10%, 106% 4%, 0% 103%" },
                { x: "28%", y: "41%", width: "29%", height: "23%", clip: "0% 90%, 106% -5%, 103% 7%, -2% 103%" }
            ]
        },
        "smeerlozeConstructies": {
            x: "34.5%", y: "41.1%",
            rect: [
                { x: "35%", y: "48.6%", width: "3.2%", height: "3.2%", clip: "0% 72%, 85% 0%, 100% 42%, 17% 103%" },
                { x: "39.3%", y: "53.7%", width: "3.6%", height: "2.9%", clip: "0% 72%, 85% 0%, 93% 28%, 17% 100%" },
            ]
        },
        "nrglassen": {
            x: "66.1%", y: "22.3%",
            rect: [
                { x: "67%", y: "29.1%", width: "1.9%", height: "2.9%", clip: "0% 38%, 107% -3%, 122% 24%, 18% 71%" },
                { x: "70.8%", y: "32.5%", width: "2%", height: "2.5%", clip: "0% 58%, 90% -3%, 113% 30%, 19% 90%" }
            ]
        },
        "strijkregels": {
            x: "73.5%", y: "15.3%",
            rect: [
                { x: "78.6%", y: "24.7%", width: "7.2%", height: "4.4%", clip: "0% 84%, 95% 0%, 114% 10%, 19% 103%" },
                { x: "72.8%", y: "19.8%", width: "5.9%", height: "4.9%", clip: "0% 84%, 95% 0%, 114% 10%, 19% 103%" }
            ]
        },
        "puntstukken": {
            x: "79%", y: "12%",
            rect: [
                { x: "77%", y: "22%", width: "5.3%", height: "4.6%", clip: "0% 71%, 83% 0%, 124% 23%, 6% 106%" }
            ]
        },
    },
    "SYMMETRIC_SWITCH": {
        "wisselstellers": {
            x: "20.5%", y: "44.5%",
            rect: [
                { x: "19%", y: "50%", width: "10%", height: "10%", clip: "-6% 33%, -6% 31%, 40% 0%, 79% 52%, 31% 84%" }
            ]
        },
        "halveTongbewegingen": {
            x: "39%", y: "38%",
            rect: [
                { x: "23.8%", y: "37%", width: "28.4%", height: "21.7%", clip: "0% 92%, 100% -1%, 106% 3%, 1% 101%" },
                { x: "28%", y: "41%", width: "29%", height: "23%", clip: "0% 95%, 103% -6%, 103% 6%, 5% 99%" }
            ]
        },
        "smeerlozeConstructies": {
            x: "34.5%", y: "41.1%",
            rect: [
                { x: "35%", y: "48.6%", width: "3.2%", height: "3.2%", clip: "0% 72%, 85% 0%, 100% 42%, 17% 103%" },
                { x: "39.3%", y: "53.7%", width: "3.6%", height: "2.9%", clip: "0% 72%, 85% 0%, 93% 28%, 17% 100%" },
            ]
        },
        "nrglassen": {
            x: "62.7%", y: "20.7%",
            rect: [
                { x: "64%", y: "27%", width: "2%", height: "2.5%", clip: "0% 58%, 90% -3%, 113% 30%, 19% 90%" },
                { x: "68%", y: "30%", width: "1.9%", height: "2.9%", clip: "0% 58%, 90% -3%, 113% 30%, 19% 90%" }
            ]
        },
        "strijkregels": {
            x: "71.5%", y: "14.3%",
            rect: [
                { x: "71.5%", y: "18.4%", width: "5.2%", height: "5%", clip: "0% 84%, 95% 0%, 114% 10%, 19% 103%" },
                { x: "77.3%", y: "23.2%", width: "6.4%", height: "4.7%", clip: "0% 86%, 95% 0%, 126% 10%, 19% 103%" }
            ]
        },
        "puntstukken": {
            x: "77%", y: "10%",
            rect: [
                { x: "75.5%", y: "20.2%", width: "4.9%", height: "5.3%", clip: "0% 69%, 77% 0%, 115% 22%, 21% 92%" }
            ]
        },
    },
    "INTERSECTION_SWITCH": {
        "puntstukken": {
            x: "81%", y: "3%",
            rect: [
                { x: "48.4%", y: "34.5%", width: "11.2%", height: "9.1%", clip: "90% -5%, 108% 17%, 26% 99%, -16% 68%" },
                { x: "79.6%", y: "16.7%", width: "5.9%", height: "4.5%", clip: "1% 70%, 85% -23%, 124% 23%, 36% 93%, 3% 109%" }
            ]
        },
        "kruisstukken": {
            x: "65%", y: "18%",
            rect: [
                { x: "65%", y: "21.6%", width: "7.6%", height: "6.5%", clip: "0% 66%, 84% 2%, 109% 37%, 19% 103%" },
                { x: "69.9%", y: "25.5%", width: "7.9%", height: "7%", clip: "0% 68%, 78% -3%, 108% 24%, 22% 99%" }
            ]
        },
        "strijkregels": {
            x: "48.7%", y: "25%",
            rect: [
                { x: "43.8%", y: "29.4%", width: "13.6%", height: "7.2%", clip: "0% 71%, 90% 2%, 94% 39%, 17% 103%" },
                { x: "56%", y: "37%", width: "9.7%", height: "11.3%", clip: "98% -1%, 99% 15%, 12% 101%, 3% 93%" },
                { x: "75.6%", y: "14.6%", width: "4.4%", height: "4.5%", clip: "-18% 89%, 100% -21%, 100% 32%, 22% 102%" },
                { x: "82.8%", y: "20.3%", width: "6.4%", height: "3.6%", clip: "0% 82%, 100% -2%, 106% 47%, 3% 123%" },
            ]
        },
        "nrglassen": {
            x: "58%", y: "21%",
            rect: [
                { x: "58.1%", y: "27.7%", width: "3%", height: "2.6%", clip: "0% 46%, 99% -2%, 96% 50%, -1% 95%" },
                { x: "63.4%", y: "32.3%", width: "3%", height: "2.6%", clip: "0% 46%, 99% -2%, 96% 50%, -1% 95%" },
                { x: "73.4%", y: "19.3%", width: "1.5%", height: "1.5%", clip: "0% 49%, 100% -29%, 89% 38%, 1% 109%" },
                { x: "78.2%", y: "22.7%", width: "1.5%", height: "1.5%", clip: "0% 65%, 100% -47%, 89% 32%, 1% 125%" },
            ]
        },
    },
    "ENGLISH_SWITCH": {
        "wisselstellers": {
            x: "48.1%", y: "29%",
            rect: [
                { x: "48.1%", y: "34%", width: "4%", height: "5.2%", clip: "0% 50%, 43% 29%, 107% 73%, 55% 105%, 1% 65%" },
                { x: "72.3%", y: "18.5%", width: "3.3%", height: "4.2%", clip: "0% 50%, 43% 29%, 107% 73%, 55% 105%, 1% 65%" }
            ]
        },
        "smeerlozeConstructies": {
            x: "64%", y: "43%",
            tooltipBottom: true,
            rect: [
                { x: "56.9%", y: "35.4%", width: "7.2%", height: "6.5%", clip: "1% 17%, 27% 0%, 92% 72%, 64% 98%, 11% 32%" },
                { x: "72.9%", y: "24.4%", width: "5.9%", height: "4.4%", clip: "3% 17%, 27% 0%, 112% 75%, 74% 103%, 3% 41%" }
            ]
        },
        "nrglassen": {
            x: "58%", y: "49%",
            tooltipBottom: true,
            rect: [
                { x: "52%", y: "42.2%", width: "4.9%", height: "4.9%", clip: "0% 18%, 21% -5%, 102% 76%, 74% 101%, 11% 41%" },
                { x: "76.6%", y: "20.7%", width: "6.4%", height: "5.4%", clip: "-1% 18%, 10% 8%, 93% 77%, 80% 89%, 13% 41%" }
            ]
        },
        "strijkregels": {
            x: "42.7%", y: "35.4%",
            rect: [
                { x: "40.7%", y: "39.4%", width: "10%", height: "6.8%", clip: "-7% 88%, 121% -21%, 97% 28%, 9% 108%" },
                { x: "47.6%", y: "44.8%", width: "8.5%", height: "8.8%", clip: "0% 88%, 89% 8%, 99% 25%, 14% 108%" },
                { x: "77.1%", y: "18.8%", width: "3.2%", height: "3%", clip: "-18% 89%, 100% -21%, 100% 32%, 22% 102%" },
                { x: "81.4%", y: "21.9%", width: "4.1%", height: "3.4%", clip: "0% 80%, 100% 3%, 100% 36%, 0% 115%" },
            ]
        },
        "halveTongbewegingen": {
            x: "56%", y: "28%",
            rect: [
                { x: "51.9%", y: "30.9%", width: "16.7%", height: "14.3%", clip: "0% 53%, 72% 0%, 82% 12%, 13% 74%, 91% 18%, 100% 31%, 33% 97%" },
                { x: "69%", y: "21.7%", width: "12.2%", height: "10%", clip: "0% 58%, 60% 0%, 82% 20%, 8% 74%, 84% 18%, 104% 40%, 33% 97%" },
            ]
        },
        "puntstukken": {
            x: "75%", y: "12.9%",
            rect: [
                { x: "79.7%", y: "19.5%", width: "4.3%", height: "4%", clip: "0% 69%, 77% 0%, 115% 22%, 21% 92%" },
                { x: "43.1%", y: "43.3%", width: "8.8%", height: "7.3%", clip: "-13% 87%, 90% -1%, 103% 25%, 12% 100%" }
            ]
        },
        "kruisstukken": {
            x: "66%", y: "22.9%",
            rect: [
                { x: "65.5%", y: "27.8%", width: "7.7%", height: "7%", clip: "0% 28%, 44% -4%, 50% 28%,11% 59%,24% 77%,71% 39%, 112% 41%, 43% 103%, 5% 51%" },
            ]
        },
    },
    "HALF_ENGLISH_SWITCH": {
        "wisselstellers": {
            x: "48.1%", y: "29%",
            rect: [
                { x: "48.1%", y: "34%", width: "4%", height: "5.2%", clip: "0% 50%, 43% 29%, 107% 73%, 55% 105%, 1% 65%" },
                { x: "72.3%", y: "18.5%", width: "3.3%", height: "4.2%", clip: "0% 50%, 43% 29%, 107% 73%, 55% 105%, 1% 65%" }
            ]
        },
        "smeerlozeConstructies": {
            x: "64%", y: "43%",
            tooltipBottom: true,
            rect: [
                { x: "56.9%", y: "35.4%", width: "4.8%", height: "4.2%", clip: "3% 17%, 27% 0%, 102% 75%, 60% 103%, 3% 41%" },
                { x: "72.9%", y: "24.4%", width: "3.9%", height: "3.4%", clip: "3% 17%, 27% 0%, 112% 75%, 74% 103%, 3% 41%" }
            ]
        },
        "nrglassen": {
            x: "58%", y: "49%",
            tooltipBottom: true,
            rect: [
                { x: "52%", y: "42.2%", width: "4.9%", height: "4.9%", clip: "0% 18%, 21% -5%, 102% 76%, 74% 101%, 11% 41%" },
                { x: "76.6%", y: "20.7%", width: "6.4%", height: "5.4%", clip: "-1% 18%, 10% 8%, 93% 77%, 80% 89%, 13% 41%" }
            ]
        },
        "strijkregels": {
            x: "42.7%", y: "35.4%",
            rect: [
                { x: "40.7%", y: "39.4%", width: "10%", height: "6.8%", clip: "-7% 88%, 121% -21%, 97% 28%, 9% 108%" },
                { x: "47.6%", y: "44.8%", width: "8.5%", height: "8.8%", clip: "0% 88%, 89% 8%, 99% 25%, 14% 108%" },
                { x: "77.1%", y: "18.8%", width: "3.2%", height: "3%", clip: "-18% 89%, 100% -21%, 100% 32%, 22% 102%" },
                { x: "81.4%", y: "21.9%", width: "4.1%", height: "3.4%", clip: "0% 80%, 100% 3%, 100% 36%, 0% 115%" },
            ]
        },
        "halveTongbewegingen": {
            x: "56%", y: "28%",
            rect: [
                { x: "52%", y: "31%", width: "15.8%", height: "13.1%", clip: "-4% 59%, 76% -3%, 83% 5%, 4% 67%, 17% 81%, 93% 21%, 97% 27%, 22% 90%" },
                { x: "69%", y: "22.3%", width: "10.2%", height: "8.2%", clip: "-2% 63%, 70% -5%, 75% 5%, 7% 74%, 26% 93%, 99% 14%, 106% 22%, 34% 102%" }
            ]
        },
        "puntstukken": {
            x: "75%", y: "12.9%",
            rect: [
                { x: "79.7%", y: "19.5%", width: "4.3%", height: "4%", clip: "0% 69%, 77% 0%, 115% 22%, 21% 92%" },
                { x: "43.1%", y: "43.3%", width: "8.8%", height: "7.3%", clip: "-13% 87%, 90% -1%, 103% 25%, 12% 100%" }
            ]
        },
        "kruisstukken": {
            x: "66%", y: "22%",
            rect: [
                { x: "64.6%", y: "27.8%", width: "7.9%", height: "7.9%", clip: "0% 28%, 44% -4%, 50% 28%,11% 59%,24% 77%,71% 39%, 112% 41%, 43% 103%, 5% 51%" }
            ]
        },
    }
};
